module.exports = __webpack_public_path__ + "static/media/junte-pontos.bf355591.png";